module.exports = __webpack_public_path__ + "img/banner_6.23b842c0.jpg";